import { Navigate, useSearchParams } from 'react-router-dom';
import {
  SETTINGS_SECTIONS,
  type SettingsSectionId,
} from './components/SettingsSidebar';

const SECTION_IDS = new Set<SettingsSectionId>(SETTINGS_SECTIONS.map((s) => s.id));

/**
 * `/settings` — redirects legacy `?section=` query to `/settings/:sectionId`.
 */
export function SettingsEntryRedirect() {
  const [searchParams] = useSearchParams();
  const section = searchParams.get('section');
  if (section === 'whatsapp-pricing') return <Navigate to="/settings/channels?tab=pricing" replace />;
  if (section === 'resend') return <Navigate to="/settings/integrations" replace />;
  if (section === 'meta' || section === 'meta-channels' || section === 'servidores-uazapi') {
    return <Navigate to={section === 'servidores-uazapi' ? '/settings/channels?tab=uazapi' : '/settings/channels'} replace />;
  }
  if (section === 'gateways') return <Navigate to="/settings/financial?tab=gateways" replace />;
  if (section === 'branding' || section === 'platform') {
    return <Navigate to={section === 'branding' ? '/settings/general?tab=appearance' : '/settings/general'} replace />;
  }
  if (section && SECTION_IDS.has(section as SettingsSectionId)) {
    return <Navigate to={`/settings/${section}`} replace />;
  }
  return <Navigate to="/settings/general" replace />;
}
